<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("denomination", 2) }}
      </div>
      <router-link class="btn-blue" to="denominations"
        >{{ $tc("denomination", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="dropdown-curve-container">
            <label :class="selected.country.length > 0 ? 'shift-up' : ''"
              >{{ $tc("country", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.country"
                variant="dropdown-curve"
                class="w-100"
                 v-b-tooltip.hover
                :title="$t('denominationcountry_tooltip')"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Country"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCountry()"
                    v-on:keydown="onSearchCountry()"
                    v-on:search="onSearchCountry()"
                    v-model="searchCountry"
                  />
                </div>
                <b-dropdown-item
                  v-for="(country, countryIndex) in Countries"
                  @click="onSelectCountry($event, country)"
                  :key="countryIndex"
                  name="select_country"
                  id="select_country"
                  >{{ country.country_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('denominationcountry_tooltip')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && selected.country.length == 0">{{
                messagecountry
              }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="dropdown-curve-container">
            <label :class="selected.currency.length > 0 ? 'shift-up' : ''"
              >{{ $tc("currency", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.currency"
                variant="dropdown-curve"
                class="w-100"
                v-b-tooltip.hover
               :title="$t('denominationcurreny_tooltip')"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Currency"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCurrency()"
                    v-on:keydown="onSearchCurrency()"
                    v-on:search="onSearchCurrency()"
                    v-model="searchCurrency"
                  />
                </div>
                <b-dropdown-item
                  v-for="(currency, currencyIndex) in Currencies"
                  :key="currencyIndex"
                  @click="onSelectCurrency($event, currency)"
                  name="select_currency"
                  id="select_currency"
                  >{{ currency.curr_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('denominationcurreny_tooltip')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && selected.currency.length == 0">{{
                messagecurrency
              }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="denominationsObject.denomination_value"
                type="text"
                name="denomination_val"
                id="denomination_val"
                v-validate="'required|decimal'"
                v-b-tooltip.hover
               :title="$t('denominationvalue_tooltip')"
              />
              <!-- v-validate="{required: 'required', regex:'[0-9]||[0-9]*\\.[0-9]*$'}" -->
              <label>{{ $tc("denomination", 1) }} {{ $t("value") }}</label>
            </div>
            <!-- <Tooltip :title="$t('denominationvalue_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('denomination_val')">{{
              errors.first("denomination_val")
            }}</span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-2 align-self-center mb-2">
          <div class="d-flex align-items-center">
            
            <b-form-checkbox
              unchecked-value="N"
              v-model="denominationsObject.denomination_is_active"
              value="Y"
              name="check-button"
              class="j-checkbox"
            ></b-form-checkbox>
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-2">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <button @click.prevent.stop="onResetForm" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="denominations"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      messagecountry: "Please select country",
      messagecurrency: "Please select currency",
      submitted: false,
      Countries: [],
      CountriesCopy: [],
      CurrenciesCopy: [],
      searchCountry: "",
      searchCurrency: "",
      Currencies: [],
      selected: {
        country: "Select Country",
        currency: "Select Currency"
      },
      denominationsObject: {
        denomination_id: null,
        denomination_value: null,
        denomination_is_active: "N",
        country_id: null,
        country_name: "",
        currency_id: null,
        curr_code: "",
        created_at: null,
        created_by: null,
        updated_at: null,
        updated_by: null
      }
    };
  },
  beforeMount() {
    const { id } = this.$route.query;
    if (id) {
      this.getDenominationDetails(id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    onSearchCountry: function(value) {
      if (this.searchCountry && this.searchCountry.length > 0) {
        this.Countries = this.CountriesCopy.filter(x => {
          if (
            x.country_name
              .toLowerCase()
              .includes(this.searchCountry.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Countries = this.CountriesCopy;
      }
    },
    onSearchCurrency: function() {
      if (this.searchCurrency && this.searchCurrency.length > 0) {
        this.Currencies = this.CurrenciesCopy.filter(x => {
          if (
            x.curr_name
              .toLowerCase()
              .includes(this.searchCurrency.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Currencies = this.CurrenciesCopy;
      }
    },
    /* eslint-disable */
    getDenominationDetails: function(denomination_id) {
      MasterService.GetDenominationById({ denomination_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.denominationsObject = {
              ...data.Records[0],
              currency_id: data.Records[0].curr_id
            };
            this.getCountryList(data.Records[0].country_id);
            this.getCurrencyList(data.Records[0].curr_id);
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getDenominationList :", error);
        });
    },
    getCountryList: function(country_id) {
      this.Countries = [];
      let payload = {
        tableName: "ms_countries",
        country_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            this.CountriesCopy = data.Records;
            this.Countries.map(x => {
              if (x.country_id == country_id) {
                this.selected.country = x.country_name;
              }
            });
          } else {
            // Shoe Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    getCurrencyList: function(curr_id) {
      this.Currencies = [];
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Currencies = data.Records;
            this.CurrenciesCopy = data.Records;
            this.Currencies.map(x => {
              if (x.curr_id == curr_id) {
                this.selected.currency = x.curr_name;
              }
            });
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    onSelectCountry: function(event, params) {
      this.selected.country = params.country_name;
      this.denominationsObject.country_id = params.country_id;
    },
    onSelectCurrency: function(event, params) {
      this.selected.currency = params.curr_name;
      this.denominationsObject.currency_id = params.curr_id;
    },
    onResetForm: function() {
      this.selected = {
        country: "",
        currency: ""
      };
      this.denominationsObject.denomination_value = "";
      // this.denominationsObject = {
      //   denomination_id: null,
      //   denomination_value: null,
      //   denomination_is_active: "N",
      //   country_id: null,
      //   country_name: "",
      //   currency_id: null,
      //   curr_code: "",
      //   created_at: null,
      //   created_by: null,
      //   updated_at: null,
      //   updated_by: null
      // };
    },
    goToRoute: function(path) {
      this.$router.push({
        path: path,
        query: {
          id: this.denominations.denomination_id
        }
      });
    },
    onFinalSubmit: function(redirect) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (
          this.denominationsObject.country_id == null ||
          this.denominationsObject.currency_id == null
        ) {
          return;
        }
        if (valid) {
          this.btenable = true;
          MasterService.UpdateDenomination(this.denominationsObject)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.onResetForm();
                if (redirect) {
                  this.$router.push({
                    path: "/master/denominations"
                  });
                }
              } else {
                // Show Error Message:
                console.log("data.message :", data.message);
              }
            })
            .catch(error => {
              // Catch Error:
              console.log("Catch Error On AddDenomination :", error);
            });
        }
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/DenominationsComponents/editDenomination.vue